export const formatoState = {
    listado: [],
    isLoading: false,
    message: '',
    severity: '',
}